export const splitArrayIntoChunks = <T>(array: Array<T>, chunkSize: number): Array<Array<T>> => Array.from(
  new Array(Math.ceil(array.length / chunkSize)),
  (_, index) => array.slice(index * chunkSize, index * chunkSize + chunkSize),
)
